<template>
  <div>
    <Card>
      <ui-date-time-picker
        :value="new Date()"
        :withTimeFilter="true"
        :minDate="new Date()"
      ></ui-date-time-picker>
    </Card>
    <Card>
      <ui-date-time-picker
        :value="new Date()"
        :withTimeFilter="false"
        :maxDate="new Date()"
      ></ui-date-time-picker>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

</script>
